/* Nector loyalty-points callout hydration. Loaded once per page (deferred)
   from layout/theme.liquid rather than inline, because the cart-drawer
   footer is replaced via element.replaceWith() on cart refresh, which does
   not re-execute inline scripts — page-level load keeps the delegated
   listeners and MutationObserver-driven re-hydration attached across cart
   updates. Balance comes from window.nector_data at runtime; the two
   constants below are the documented redemption rule. No Liquid values. */
      (function () {
        var latestBalance = null;
        var POINT_VALUE_INR = 1;       /* 1 point = ₹1 off */
        var MAX_REDEEM_INR = 5000;     /* ₹5000 cap per order */

        function formatInr(amount) {
          try { return '₹' + Number(amount).toLocaleString('en-IN'); }
          catch (e) { return '₹' + amount; }
        }

        function hydrateAll() {
          /* Discount text — value capped at MAX_REDEEM_INR (per-order cap). */
          var discountText = '₹…';
          /* Header badge text — uncapped wallet balance (full points value). */
          var badgeText    = '₹…';
          if (latestBalance != null) {
            var redeemableInr = Math.min(latestBalance * POINT_VALUE_INR, MAX_REDEEM_INR);
            var walletInr     = latestBalance * POINT_VALUE_INR;
            discountText = formatInr(redeemableInr);
            badgeText    = formatInr(walletInr);
          }
          var dNodes = document.querySelectorAll('[data-nector-discount]');
          for (var i = 0; i < dNodes.length; i++) dNodes[i].textContent = discountText;
          var bNodes = document.querySelectorAll('[data-nector-points-badge]');
          for (var j = 0; j < bNodes.length; j++) bNodes[j].textContent = badgeText;
        }

        function readFromGlobal() {
          /* Nector exposes the points balance at window.nector_data.wallet.available
             as a string ("100.00000000"). Falls back to nector_data.lead.wallet.available
             which holds the same value. */
          var raw = (window.nector_data
              && ((window.nector_data.wallet && window.nector_data.wallet.available)
                || (window.nector_data.lead && window.nector_data.lead.wallet && window.nector_data.lead.wallet.available)));
          if (raw == null) return false;
          var n = parseFloat(raw);
          if (isNaN(n)) return false;
          latestBalance = Math.floor(n);
          return true;
        }

        if (readFromGlobal()) hydrateAll();

        window.addEventListener('nector_lead_updated', function () {
          if (readFromGlobal()) hydrateAll();
        });

        /* NOTE: no cartUpdate subscribe here. In the inline original this ran
           before the deferred pubsub.js, so the subscription never registered
           (dead); the MutationObserver below is the actual re-hydration path.
           As a deferred asset it would register — harmless (idempotent text
           writes) but redundant with the observer — so it's kept dead to
           preserve exact prior behavior. */

        /* Belt-and-braces: MutationObserver catches any DOM replacement
           that re-introduces a [data-nector-discount] or
           [data-nector-points-badge] placeholder (e.g. cart drawer
           footer replaceWith(), header refetch, section-id rerender)
           and immediately re-hydrates it. */
        function rehydrateIfPlaceholderAdded(mutations) {
          for (var m = 0; m < mutations.length; m++) {
            var added = mutations[m].addedNodes;
            for (var n = 0; n < added.length; n++) {
              var node = added[n];
              if (!node || node.nodeType !== 1) continue;
              var sel = '[data-nector-discount], [data-nector-points-badge]';
              if ((node.matches && node.matches(sel)) ||
                  (node.querySelector && node.querySelector(sel))) {
                hydrateAll();
                return;
              }
            }
          }
        }

        document.addEventListener('click', function (e) {
          if (e.target && e.target.closest && e.target.closest('[data-nector-callout]')) {
            if (typeof window.showNectorRewards === 'function') window.showNectorRewards();
          }
        });

        /* Header rewards wallet trigger — same call as the cart callout,
           lives in the site header (sections/header.liquid) as
           .header__icon--rewards. Click opens Nector's rewards modal;
           the close × overlay defined below provides the dismiss UX. */
        document.addEventListener('click', function (e) {
          if (e.target && e.target.closest && e.target.closest('[data-nector-header-trigger]')) {
            if (typeof window.showNectorRewards === 'function') window.showNectorRewards();
          }
        });

        /* Hide Nector's default floating rewards pill at runtime. CSS
           alone can't win because Nector injects its stylesheet AFTER
           ours; inline style is the highest specificity. The pill is
           redundant now that the header wallet button is the canonical
           rewards entry point. Previously lived in floating-contact.liquid
           but moved here so it runs on every page even when that snippet
           isn't rendered. */
        function hideNectorDefaultPill() {
          var pill = document.getElementById('nector-rewards-widget-container');
          if (pill && pill.style.display !== 'none') {
            pill.style.setProperty('display', 'none', 'important');
          }
        }
        hideNectorDefaultPill();

        /* Reposition Nector's modal container to the top-RIGHT on
           desktop so it visually expands from the wallet icon in the
           header (which is where the trigger lives). Nector's default
           is top-left which feels disconnected from the trigger.
           Mobile is left untouched — Nector renders a full-bleed sheet
           on mobile and our overrides would collapse it to a tiny box.

           The modal renders ASYNC after showNectorRewards() returns, so
           the click handler below polls briefly. The MutationObserver
           also re-applies on any Nector re-render (internal route
           changes, etc.). */
        var NECTOR_RIGHT_OFFSET  = 24;  /* px from right edge of viewport */
        var NECTOR_TOP_OFFSET    = 90;  /* px from top — clears the sticky header */

        function repositionNectorModal() {
          var container = document.querySelector('.nector-iframe-container');
          if (!container) return false;
          var isDesktop = window.matchMedia('(min-width: 750px)').matches;
          if (!isDesktop) return true;
          container.style.setProperty('top', NECTOR_TOP_OFFSET + 'px', 'important');
          container.style.setProperty('left', 'auto', 'important');
          container.style.setProperty('right', NECTOR_RIGHT_OFFSET + 'px', 'important');
          container.style.setProperty('bottom', 'auto', 'important');
          container.style.setProperty('max-height', 'calc(100vh - ' + (NECTOR_TOP_OFFSET + 24) + 'px)', 'important');
          return true;
        }
        repositionNectorModal();

        /* Guest login nudge — forward the click to the header's Kwikpass
           trigger so the user sees exactly the same login modal/OTP flow
           they'd get from the profile icon in the header. Synthetic .click()
           dispatches a real MouseEvent that the Kwikpass SDK listens for.

           Fallback: if the Kwikpass trigger isn't in the DOM (e.g., app
           embed not loaded, header hidden on certain templates), navigate
           to /account/login so the user is never stranded. */
        document.addEventListener('click', function (e) {
          var nudge = e.target && e.target.closest && e.target.closest('[data-nector-login-nudge]');
          if (!nudge) return;
          var kpTrigger = document.getElementById('kp-login-button-header-logo');
          if (kpTrigger) {
            kpTrigger.click();
          } else {
            window.location.assign('/account/login?return_url=/cart');
          }
        });

        /* Nector's rewards modal renders without a visible close affordance
           on desktop (the cart-callout entry path doesn't open via our
           floating widget, so the toggle/Esc UX from floating-contact.liquid
           may not be reachable when that snippet is disabled). Inject a
           floating × button anchored to the modal whenever it is present,
           so users always have a clear way to dismiss the panel.

           Mobile is skipped because Nector renders its mobile sheet
           full-screen with its own in-iframe close affordance — adding
           another × there would clutter the layout. */
        var NECTOR_CLOSE_ID = 'fc-nector-close-overlay';

        function ensureNectorCloseButton() {
          var isDesktop = window.matchMedia('(min-width: 750px)').matches;
          var container = document.querySelector('.nector-iframe-container');
          var existing = document.getElementById(NECTOR_CLOSE_ID);

          /* No modal or mobile viewport → remove any stale overlay. */
          if (!container || !isDesktop) {
            if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
            return;
          }
          if (existing) return; /* already attached */

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.id = NECTOR_CLOSE_ID;
          btn.setAttribute('aria-label', 'Close rewards panel');
          btn.innerHTML =
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
            '<path d="M6 6l12 12M6 18L18 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>' +
            '</svg>';
          /* Inline styles only — no chance of a Nector stylesheet override. */
          var s = btn.style;
          s.setProperty('position', 'absolute', 'important');
          s.setProperty('top', '12px', 'important');
          s.setProperty('right', '12px', 'important');
          s.setProperty('width', '32px', 'important');
          s.setProperty('height', '32px', 'important');
          s.setProperty('display', 'inline-flex', 'important');
          s.setProperty('align-items', 'center', 'important');
          s.setProperty('justify-content', 'center', 'important');
          s.setProperty('border', 'none', 'important');
          s.setProperty('border-radius', '50%', 'important');
          s.setProperty('background', '#004E32', 'important');
          s.setProperty('color', '#FFFFFF', 'important');
          s.setProperty('cursor', 'pointer', 'important');
          s.setProperty('z-index', '99999999', 'important');
          s.setProperty('box-shadow', '0 4px 12px rgba(0, 0, 0, 0.18)', 'important');
          s.setProperty('padding', '0', 'important');
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof window.hideNectorRewards === 'function') {
              try { window.hideNectorRewards(); } catch (err) { /* no-op */ }
            }
            /* Remove the overlay immediately — MutationObserver will also
               catch the container removal as a backup. */
            if (btn.parentNode) btn.parentNode.removeChild(btn);
          });
          container.appendChild(btn);
        }

        /* Initial pass in case the modal is already open at script-run. */
        ensureNectorCloseButton();

        /* Single shared body observer. Nector injects its floating pill and its
           modal container directly under <body> at an uncontrolled position, and
           the globally-rendered cart drawer + header re-render the points
           placeholders in place — so the watch must stay whole-body + subtree.
           One observer running all four handlers per mutation batch replaces the
           four independent observers that each did the same whole-body work:
           identical behaviour, a quarter of the callback churn. Handlers run in
           the original registration order (rehydrate, pill, reposition, close). */
        if (typeof MutationObserver !== 'undefined') {
          var nectorBodyObserver = new MutationObserver(function (mutations) {
            rehydrateIfPlaceholderAdded(mutations); /* re-hydrate points text    */
            hideNectorDefaultPill();                /* hide Nector default pill   */
            repositionNectorModal();                /* reposition modal (desktop) */
            ensureNectorCloseButton();              /* add/remove modal close ×   */
          });
          nectorBodyObserver.observe(document.body, { childList: true, subtree: true });
        }

        /* Esc closes — duplicates the Esc handler in floating-contact.liquid
           but covers pages where that snippet is disabled (e.g. when
           settings.floating_contact_enable is off). Both call the same
           hideNectorRewards() which is idempotent, so no double-close issue. */
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          var container = document.querySelector('.nector-iframe-container');
          if (!container) return;
          if (typeof window.hideNectorRewards === 'function') {
            try { window.hideNectorRewards(); } catch (err) { /* no-op */ }
          }
        });
      })();
